import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import SearchBooks from '@/components/screens/search/search-books/SearchBooks';
import { IBookPage } from '@/interfaces/booksPage.interface';
import { API_URL, BOOKS_FOR_PAGE } from '@/helpers/variables';

interface IBookSearchPageDynamic {
  books: IBookPage;
  totalAlias: string;
}

const BookSearchPageDynamic: NextPage<IBookSearchPageDynamic> = ({ books, totalAlias }) => {
  return <SearchBooks books={books} totalAlias={totalAlias} type="drafts" />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { totalAlias } = context.query;

  const [booksRes] = await Promise.all([fetch(`${API_URL}satellite/books?book_type=book&search_text=${totalAlias}&page=1&page_size=${BOOKS_FOR_PAGE}`)]);
  const [books] = await Promise.all([booksRes.json()]);

  return {
    props: {
      books,
      totalAlias,
    },
  };
};

export default BookSearchPageDynamic;
